<template>
 <nav class="navbar navbar-secondary navbar-expand-lg navbar-light bg-secondary mb-5" id="navbarSecondary">
    <div class="container container-navbar-secondary" id="navbarSecondaryContainer">
            <ul class="navbar-nav mr-auto navbar-ul-luetfrink">
                <button class="left-scroller" id="left-scroller" @click="scrollLeft" aria-label="scroll-left-button"></button>
                <button class="right-scroller" id="right-scroller"  @click="scrollRight" aria-label="scroll-right-button"></button>
                <li class="nav-item nav-item-secondary">
                    <a class="nav-link nav-link-secondary text-white" @click='toggleNav("windzone")' v-bind:class="[this.getActiveLink == 'windzone' ? 'active' : '']" id="windzoneNav">1. Windzone & Standort</a>
                </li>
                <li class="nav-item nav-item-secondary">
                    <a class="nav-link nav-link-secondary text-white" @click='toggleNav("gebaeude")'  v-bind:class="[getActiveLink == 'gebaeude' ? 'active' : '']" id="gebaeudeNav">2. Gebäude</a>
                </li>
                <li class="nav-item nav-item-secondary">
                    <a class="nav-link nav-link-secondary text-white" @click='toggleNav("dach")'  v-bind:class="[getActiveLink == 'dach' ? 'active' : '']" id="dachNav">3. Dach & Pfannenmodell</a>
                </li>
                <li class="nav-item nav-item-secondary">
                    <a class="nav-link nav-link-secondary text-white" @click='calculate()'  v-bind:class="[getActiveLink == 'berechnung' ? 'active' : '']" id="berechnungNav">4. Berechnung</a>
                </li>
            </ul>
            
            <ul class="navbar-nav">

            </ul>
    </div>
</nav>

      
</template>


<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'SecondNavbar',
    data() {
        return {
            
        }
    },
    methods:{
        ...mapActions(['changeActiveLink', 'incrementTrigger', 'changeActiveContent']),
        toggleNav(active)
        {
            this.changeActiveLink(active);
            if(this.isErlaubt)
            {
                if(active == "berechnung" && this.$store.state.inputs.calculationResult != null)
                    this.changeActiveContent(active);
                else if(active != "berechnung")
                    this.changeActiveContent(active);
            }
            this.incrementTrigger();
            setTimeout(function(){ 
                window.location.href = "#"+active+"Anchor";
            }, 250);
            
        },
        scrollLeft(){
            var secondNav = document.getElementById("navbarSecondaryContainer")
            //var left = document.getElementById("left-scroller")
            //var right = document.getElementById("right-scroller")
            secondNav.scrollLeft = secondNav.scrollLeft - 300;
        },
        scrollRight(){
            var secondNav = document.getElementById("navbarSecondaryContainer")
            //var left = document.getElementById("left-scroller")
            //var right = document.getElementById("right-scroller")
            secondNav.scrollLeft = secondNav.scrollLeft + 300;

        },
        calculate(){
          if(this.isComplete)
          {
            console.log("berechnen");
            this.$root.$emit('calculate');
            
          } 
          this.toggleNav("berechnung");
        }
    } ,
    computed: {
        ...mapGetters(['getActiveLink', 'getActiveTrigger', 'getActiveContent', 'isErlaubt', 'getCalculationsCorrect', 'isComplete']),
    }
        
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.navbar-secondary
{
    height: 50px;
    position: fixed;
    top: 68px;
    padding: 0px;
    width: 100%;
    z-index: 6;
    overflow: hidden;
    
}


.left-scroller
{
    height: 50px;
    position: fixed;
    top:68px;
    left:0;
    width: 30px;
    background-image: url("../assets/img/ScrollArrowLeft.svg");
    background-size: 25px 40px;
    background-repeat: no-repeat;
    background-position:  center center;
    background-color: rgba(255, 255, 255, 0);
    border: none;
    display: none;
    opacity: 0.3;
}

.right-scroller
{
    height: 50px;
    position: fixed;
    top:68px;
    right: 0;
    width: 30px;
    background-image: url("../assets/img/ScrollArrowRight.svg");
    background-size: 25px 40px;
    background-position:  center center;
    background-repeat: no-repeat;
    padding-left: 0;
    background-color:  rgba(255, 255, 255, 0);
    border: none;
    display: none;
    opacity: 0.3;
}

.navbar-ul-luetfrink
{
    display: inline-flex;  
    flex-direction: row;
}

.nav-link-secondary
{
    cursor: pointer;
    padding-top: 12px;
    padding-bottom: 11px;
    padding-left: 2.1rem !important;
    padding-right: 2.1rem !important;
    font-size: 20px;
    font-weight: 300;
    transition: background-color .2s ease;
}

.nav-link-secondary:hover
{
    background-color: #393939;
}

.nav-link-secondary.active
{
    background-color: #006FBA;
    background-image: url("../assets/img/triangle.svg");
    background-position:  bottom center;
    background-size: 12px 8px;
    background-repeat:no-repeat;
}

@media (max-width:1010px) {
.container-navbar-secondary::-webkit-scrollbar {
    width: 2px;
    height: 0px;
    background: white;
    opacity: 0;
}

.container-navbar-secondary::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.2); 
    border-radius: 1px;
     opacity: 0;
}

.container-navbar-secondary::-webkit-scrollbar-thumb {
    border-radius: 1px;
    background: white;
    -webkit-box-shadow: inset 0 0 6px rgba(39, 39, 39, 0.4); 
     opacity: 0;
}
}
@media (max-width:1010px) {
    .container-navbar-secondary
    {
        white-space: nowrap;
        scroll-behavior: smooth;
    }
    .left-scroller
    {
        display: inherit;
    }

    .right-scroller
    {
        display: inherit;
    }
}

@media (max-width:992px) {
    .container-navbar-secondary
    {
        width: 100%;
        max-height: 50px;
        overflow-y: hidden;
        overflow-x: auto;
        white-space: nowrap;
    }
}

@media (max-width:575.98px) {
    .navbar-secondary
    {
        height: 50px;
        top: 55px;   
   
    }
    .container{
        margin: 0;
        padding: 0;
    }
    .nav-link-secondary
    {
        font-size: 1.1em;
        padding-top: 13px;
        padding-bottom: 12px;
    }

    .left-scroller
    {
        top:55px;
    }

    .right-scroller
    {
        top:55px;
    }
}



</style>
